import { useState, useCallback } from 'react';

export const useAdminClientKeywordStuffing = ({
  setSidebarCollapsed,
  handleScrollBottom,
  actualHtmlContent,
  setActualHtmlContent,
  textTitle,
  keywords,
  extractWords,
  textType,
  initialTextContent,
  actualTextContent,
  initialTextWordCount,
  actualTextWordCount,
  setStuffedKeywords,
  deliverText,
  t,
  setActualTextContent,
  setInitialHtmlContent,
}) => {
  const [keywordStuffingLoading, setKeywordStuffingLoading] = useState(false);
  const [initialStuffedKeywords, setInitialStuffedKeywords] = useState([]);
  const [showKeywordStuffingModal, setShowKeywordStuffingModal] = useState(false);
  const [keywordStuffingModalTitle, setKeywordStuffingModalTitle] = useState('');
  const [keywordStuffingModalMsg, setKeywordStuffingModalMsg] = useState('');
  const [keywordStuffingModalData, setKeywordStuffingModalData] = useState([]);
  const [keywordStuffingModalCloseBtn, setKeywordStuffingModalCloseBtn] = useState(false);

  const keywordStuffingCall = useCallback(async () => {
    try {
      setKeywordStuffingLoading(true);
      
      // Logique de détection de keyword stuffing pour AdminClient
      const stuffedKeywords = extractWords(actualTextContent, keywords);
      
      if (stuffedKeywords && stuffedKeywords.length > 0) {
        setStuffedKeywords(stuffedKeywords);
        setKeywordStuffingModalTitle(t('Keyword stuffing détecté'));
        setKeywordStuffingModalMsg(t('Des mots-clés ont été détectés en surplus dans le texte.'));
        setKeywordStuffingModalData(stuffedKeywords);
        setKeywordStuffingModalCloseBtn(true);
        setShowKeywordStuffingModal(true);
      } else {
        // Pas de keyword stuffing, livrer directement
        await deliverText('deliver');
      }
    } catch (error) {
      console.error('Erreur lors de la détection de keyword stuffing:', error);
    } finally {
      setKeywordStuffingLoading(false);
    }
  }, [
    actualTextContent,
    keywords,
    extractWords,
    setStuffedKeywords,
    deliverText,
    t,
  ]);

  return {
    keywordStuffingLoading,
    initialStuffedKeywords,
    showKeywordStuffingModal,
    keywordStuffingModalTitle,
    keywordStuffingModalMsg,
    keywordStuffingModalData,
    keywordStuffingModalCloseBtn,
    keywordStuffingCall,
    setShowKeywordStuffingModal,
    setInitialStuffedKeywords,
  };
};
